import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilledCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.267 0.023 C 7.037 0.264,4.158 1.825,2.211 4.391 C 1.099 5.857,0.406 7.531,0.100 9.496 C -0.012 10.215,-0.012 11.785,0.100 12.504 C 0.570 15.521,2.029 17.997,4.394 19.791 C 5.854 20.899,7.537 21.595,9.496 21.900 C 10.215 22.012,11.785 22.012,12.504 21.900 C 15.177 21.483,17.449 20.278,19.154 18.373 C 20.666 16.684,21.539 14.816,21.900 12.504 C 22.012 11.785,22.012 10.215,21.900 9.496 C 21.595 7.537,20.899 5.854,19.791 4.394 C 17.972 1.996,15.372 0.488,12.375 0.091 C 11.946 0.034,10.670 -0.007,10.267 0.023 M16.118 6.767 C 16.359 6.916,16.509 7.162,16.529 7.439 C 16.560 7.863,16.723 7.680,13.061 11.339 C 10.721 13.678,9.695 14.681,9.599 14.720 C 9.406 14.800,9.074 14.791,8.873 14.701 C 8.636 14.594,5.646 11.604,5.539 11.367 C 5.344 10.932,5.536 10.416,5.973 10.206 C 6.152 10.120,6.539 10.122,6.710 10.209 C 6.781 10.245,7.383 10.817,8.049 11.480 L 9.259 12.686 12.210 9.731 C 14.178 7.761,15.211 6.752,15.308 6.705 C 15.533 6.597,15.886 6.623,16.118 6.767 ",
		fill: "currentColor",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgFilledCheckmark;
